const getDefaultState = () => {
  return {
    fromPath: {},
  };
};

const routeHistory = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    isFrom: state => name => {
      return state.fromPath.name === name;
    },
    isMatched: state => name => {
      return state.matched ? state.fromPath.filter(elem => elem.name === name).length > 0 : false;
    },
  },
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setFromPath (state, from) {
      state.fromPath = from;
    },
  },
};

export default routeHistory;
